import { type SugarVerificationCategory } from '@app/types'

export const VERIFICATION_CATEGORIES = [
  'age_verification',
  'address_verification',
  'income_verification'
] as const satisfies readonly SugarVerificationCategory[]

// Title-cased labels for standalone UI elements such as select options.
// Use getCategoryLabel() when the label needs to read naturally in sentence-style copy
// (for example: "...your {documentTypeLabel} stays in our secure system...").
export const CATEGORY_LABELS: Record<SugarVerificationCategory, string> = {
  address_verification: 'Address Verification',
  age_verification: 'Age Verification',
  income_verification: 'Income Verification'
}

export const getCategoryLabel = (category: string): string => {
  const label = CATEGORY_LABELS[category as SugarVerificationCategory] ?? category

  return `${label.toLowerCase()} document`
}

export const CATEGORY_SELECT_OPTIONS = VERIFICATION_CATEGORIES.map((value) => ({
  label: CATEGORY_LABELS[value],
  value
}))
